import {
    ExtrudeGeometry,
    Group,
} from 'three';
import * as THREE from "three";
import {GLTFLoader} from "three/addons";

export class TableFrame extends Group {

    constructor(tabletopSize, frameMaterial, tableHeight) {
        super();

        this.inset = 20;
        this.loader = new GLTFLoader();
        this.trackInset = this.inset - 1;
        this.height = tableHeight - 4;
        this.tracksCreated = false;


        this.createFeet(this, tabletopSize, frameMaterial);
        this.createTracks(this, tabletopSize, frameMaterial);
        this.createPoles(this, tabletopSize, frameMaterial, tableHeight);
        this.createCableTray(this, tabletopSize, frameMaterial);

    }

    createFeet(group, tabletopSize, frameMaterial) {
        if (group.leftFoot) {
            group.leftFoot.position.x = -tabletopSize.width / 2 + group.inset +1;
            group.rightFoot.position.x = tabletopSize.width / 2 - group.inset - 1;
        } else {

            group.leftFoot = this.createFoot(8, 2.5, 68, 0.2, frameMaterial);
            group.leftFoot.position.x = -tabletopSize.width / 2 + group.inset +1;

            group.add(group.leftFoot);

            // Clone and position the second foot
            group.rightFoot = group.leftFoot.clone();
            group.rightFoot.position.x = tabletopSize.width / 2 - group.inset -1;
            group.add(group.rightFoot);
        }
    }

    createFoot(width, height, depth, radius = 1, frameMaterial) {
        width -=2;
        height -=1;
        depth -=2;

        let x = -width / 2;
        let y = -depth / 2;

        let shape = new THREE.Shape();
        if (radius > 0) {
            shape.moveTo(x, y + radius);
            shape.lineTo(x, y + depth - radius);
            shape.quadraticCurveTo(x, y + depth, x + radius, y + depth);
            shape.lineTo(x + width - radius, y + depth);
            shape.quadraticCurveTo(x + width, y + depth, x + width, y + depth - radius);
            shape.lineTo(x + width, y + radius);
            shape.quadraticCurveTo(x + width, y, x + width - radius, y);
            shape.lineTo(x + radius, y);
            shape.quadraticCurveTo(x, y, x, y + radius);
        } else {
            shape.moveTo(x, y);
            shape.lineTo(x, y + depth);
            shape.lineTo(x + width, y + depth);
            shape.lineTo(x + width, y);
            shape.lineTo(x, y);
        }

        const extrudeSettings = {
            depth: height,
            bevelEnabled: true,
            bevelSegments: 8,
            steps: 2,
            bevelSize: 1,
            bevelThickness: 0.5
        };
        let mesh = new THREE.Mesh(new ExtrudeGeometry(shape, extrudeSettings), frameMaterial);
        mesh.position.y = 1;
        mesh.rotation.x = -Math.PI / 2;
        mesh.castShadow = true;
        mesh.receiveShadow = true;
        return mesh
    }


    createTracks(group, tabletopSize, frameMaterial) {
        if (group.tracksCreated) {
            if(group.leftTrack){
                group.leftTrack.position.x = -tabletopSize.width / 2 + group.trackInset;
                group.rightTrack.position.x = tabletopSize.width / 2 - group.trackInset;
            }
        } else {
            group.tracksCreated = true;
            group.loader.load('/3ds/desk-frame/zijkant.gltf', function (gltf) {
                const scale = .1;
                group.leftTrack = gltf.scene;

                group.leftTrack.traverse(function (node) {
                    if (node.isMesh) {
                        node.castShadow = true;
                        node.receiveShadow = true;
                        node.material = frameMaterial;
                    }
                });
                group.leftTrack.scale.set(scale * group.leftTrack.scale.x, scale * group.leftTrack.scale.y, scale * group.leftTrack.scale.z)
                group.leftTrack.position.x = -tabletopSize.width / 2 + group.trackInset;
                group.leftTrack.position.y = group.height + 1.6;
                group.leftTrack.position.z = 0;
                group.leftTrack.rotation.y = Math.PI / 2;
                group.leftTrack.receiveShadow = true;
                group.leftTrack.castShadow = true;

                group.add(group.leftTrack);

                // Clone and position the second foot
                group.rightTrack = group.leftTrack.clone();
                group.rightTrack.position.x = tabletopSize.width / 2 - group.trackInset;
                group.rightTrack.rotation.y = -Math.PI / 2;
                group.add(group.rightTrack);

            }, undefined, function (error) {
                console.error(error);
            });
        }
    }

    createPoles(group, tabletopSize, frameMaterial, tableHeight) {

        const feetHeight = 2;
        const bottomPoleHeight = 53;
        const middlePoleHeight = bottomPoleHeight + 5;
        const topPoleHeight = middlePoleHeight + 5;

        if (group.leftBottomPole) {
            group.leftBottomPole.position.x = -tabletopSize.width / 2 + group.inset + 1;
        } else {
            group.leftBottomPole = new THREE.Mesh(new THREE.BoxGeometry(7, bottomPoleHeight, 7), frameMaterial);
            group.leftBottomPole.position.x = -tabletopSize.width / 2 + group.inset + 1;
            group.leftBottomPole.position.y = feetHeight + bottomPoleHeight / 2;
            group.leftBottomPole.castShadow = true;
            group.leftBottomPole.receiveShadow = true;
            group.add(group.leftBottomPole)
        }

        if (group.leftMiddlePole) {
            group.leftMiddlePole.position.x = -tabletopSize.width / 2 + group.inset + 1;
        } else {
            group.leftMiddlePole = new THREE.Mesh(new THREE.BoxGeometry(6, middlePoleHeight, 6), frameMaterial);
            group.leftMiddlePole.position.x = -tabletopSize.width / 2 + group.inset + 1;
            group.leftMiddlePole.position.y = feetHeight + middlePoleHeight / 2;
            group.leftMiddlePole.castShadow = true;
            group.leftMiddlePole.receiveShadow = true;
            group.add(group.leftMiddlePole)
        }

        if (group.leftTopPole) {
            group.leftTopPole.position.x = -tabletopSize.width / 2 + group.inset + 1;
        } else {
            group.leftTopPole = new THREE.Mesh(new THREE.BoxGeometry(5, topPoleHeight, 5), frameMaterial);
            group.leftTopPole.position.x = -tabletopSize.width / 2 + group.inset + 1;
            group.leftTopPole.position.y = tableHeight - 2 - topPoleHeight / 2;
            group.leftTopPole.castShadow = true;
            group.leftTopPole.receiveShadow = true;
            group.add(group.leftTopPole)
        }


        if (group.rightPole) {
            group.rightPole.position.x = tabletopSize.width / 2 - group.inset - 1;
        } else {
            group.rightPole = new THREE.Mesh(new THREE.BoxGeometry(7, bottomPoleHeight, 7), frameMaterial);
            group.rightPole.position.x = tabletopSize.width / 2 - group.inset - 1;
            group.rightPole.position.y = feetHeight + bottomPoleHeight / 2;
            group.rightPole.castShadow = true;
            group.rightPole.receiveShadow = true;
            group.add(group.rightPole)
        }

        if (group.rightMiddlePole) {
            group.rightMiddlePole.position.x = tabletopSize.width / 2 - group.inset - 1;
        } else {
            group.rightMiddlePole = new THREE.Mesh(new THREE.BoxGeometry(6, middlePoleHeight, 6), frameMaterial);
            group.rightMiddlePole.position.x = tabletopSize.width / 2 - group.inset - 1;
            group.rightMiddlePole.position.y = feetHeight + middlePoleHeight / 2;
            group.rightMiddlePole.castShadow = true;
            group.rightMiddlePole.receiveShadow = true;
            group.add(group.rightMiddlePole)
        }

        if (group.rightTopPole) {
            group.rightTopPole.position.x = tabletopSize.width / 2 - group.inset - 1;
        } else {
            group.rightTopPole = new THREE.Mesh(new THREE.BoxGeometry(5, topPoleHeight, 5), frameMaterial);
            group.rightTopPole.position.x = tabletopSize.width / 2 - group.inset - 1;
            group.rightTopPole.position.y = tableHeight - 2 - topPoleHeight / 2;
            group.rightTopPole.castShadow = true;
            group.rightTopPole.receiveShadow = true;
            group.add(group.rightTopPole)
        }
    }

    createCableTray(group, tabletopSize, frameMaterial) {
        if (group.cableTrayBack) {
            group.remove(group.cableTrayBack)
        }
        group.cableTrayBack = new THREE.Mesh(new THREE.BoxGeometry(tabletopSize.width - group.inset * 2 + 2.5, 4, 4), frameMaterial);
        group.cableTrayBack.position.x = 0;
        group.cableTrayBack.position.y = group.height;
        group.cableTrayBack.position.z = -4;
        group.cableTrayBack.castShadow = true;
        group.cableTrayBack.receiveShadow = true;
        group.add(group.cableTrayBack)


        if (group.cableTrayFront) {
            group.remove(group.cableTrayFront)
        }
        group.cableTrayFront = group.cableTrayBack.clone();
        group.cableTrayFront.position.z = 4;
        group.add(group.cableTrayFront);
    }

    updateHeight(height) {
        this.cableTrayBack.position.y = height - 4;
        this.cableTrayFront.position.y = height - 4;
        this.leftTrack.position.y = height - 4 + 1.6;
        this.rightTrack.position.y = height - 4 + 1.6;
        this.leftTopPole.position.y = height - 2 - this.leftTopPole.geometry.parameters.height / 2;
        this.rightTopPole.position.y = height - 2 - this.rightTopPole.geometry.parameters.height / 2;
        const middleSpacer = height * 0.17;
        this.leftMiddlePole.position.y = height - middleSpacer - this.leftMiddlePole.geometry.parameters.height / 2;
        this.rightMiddlePole.position.y = height - middleSpacer - this.rightMiddlePole.geometry.parameters.height / 2;
    }

    updateFrame(tabletopSize, frameMaterial, tableHeight) {
        this.height = tableHeight - 4;
        this.createFeet(this, tabletopSize, frameMaterial);
        this.createTracks(this, tabletopSize, frameMaterial);
        this.createPoles(this, tabletopSize, frameMaterial, tableHeight);
        this.createCableTray(this, tabletopSize, frameMaterial);
    }
}
